import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {ProductListDetailComponent} from '../product-list-detail/product-list-detail.component';
import * as moment from 'moment';
import {finalize} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from "rxjs";
import {ProductDetail} from '../product.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent implements OnInit, OnDestroy {
  itemsPerPage = 40;
  modal = null;
  modalData = null;
  searchProductID: any = '';
  searchProductName: any = '';
  groups: any = [];
  totalItems: number;
  currentPage = 1;
  loading = false;
  list: any = [];
  subs: Subscription;
  selectedValues: boolean[] = [];
  allChecked: boolean = false;
  chosenFile: string;
  parent: ProductListComponent = null;
  fileToUpload: File | null = null;
  complete = false;
  fileReport = {
    success: '',
    duplicate: '',
    operate_fail: '',
    validate_fail: ''
  }
  isSave: Boolean = true;
  productDetails: ProductDetail[] = [];

  @ViewChild('detailModal') detailModal: ProductListDetailComponent;
  @ViewChild('deleteConfirmation') deleteConfirmationModal: TemplateRef<any>;
  @ViewChild("modalTemplate") modalTemplate: TemplateRef<any>;

  constructor(private apiService: ApiService,
              private translate: TranslateService,
              private authService: AuthenticationService,
              private modalService: NgbModal
  ) {
  }

  ngOnInit() {
    this.subs = this.translate.onLangChange.subscribe((res: string) => {
    });
    this.pageChanged();
    this.isSave = false
  }

  open(parent: ProductListComponent) {
    this.isSave = true
    this.chosenFile = this.translate.instant("PRODUCT-IMPORT.NO-FILE-CHOSEN");
    this.parent = parent
    this.fileReport = {
      success: '',
      duplicate: '',
      operate_fail: '',
      validate_fail: ''
    }
    this.modal = this.modalService.open(this.modalTemplate, {
      backdrop: 'static',
      size: "lg",
      centered: true,
    });
  }

  reload() {
    this.pageChanged();
  }

  pageChanged() {
    this.loadData();
  }

  optionChanged() {
    this.search();
  }

  openModal(data, index) {
    this.detailModal.open(this, data);
  }

  search() {
    this.currentPage = 1;
    this.loadData();
  }

  loadData() {
    this.loading = true;

    const data = {
      page: this.currentPage,
      items_per_page: this.itemsPerPage,
      product_id: this.searchProductID,
      name_en: this.searchProductName
    };
    this.apiService.getProducts(data)
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        (res: any) => {
          this.productDetails = res.results;
          if (res) {
            this.totalItems = res.count;
            this.selectedValues = Array(this.productDetails.length).fill(false);
          }
        }
      );
  }

  confirmDelete(index): void {
    this.modalData = this.productDetails[index];
    this.modal = this.modalService.open(this.deleteConfirmationModal, {backdrop: 'static', centered: true});
  }

  confirmedDelete(productId: number): void {
    this.apiService.deleteProduct(productId).subscribe(
      () => {
        this.loadData();
        this.sniff('DELETE_PRODUCT', this.modalData.product_id + ';' + this.modalData.name_en);
        this.revertBack();
      });
  }


  clearSearch() {
    this.searchProductID = '';
    this.searchProductName = '';
    this.loadData();
  }

  revertBack(): void {
    this.modal.close();
    this.modal = null;
    this.modalData = null;
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'MANAGE_PRODUCT',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  selectDeselectAll(checked: boolean): void {
    this.selectedValues = Array(this.productDetails.length).fill(checked);
    this.allChecked = checked;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  get isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  get isIT(): boolean {
    return this.authService.isIT();
  }

  get isAccountant(): boolean {
    return this.authService.isAccountant();
  }

  get isAccountantAdmin(): boolean {
    return this.authService.isAccountantAdmin();
  }

  forTemplate(type) {
    if (type === 'csv') {
      this.apiService.getTemplateCSVABB().subscribe(
        data => {
          this.apiService.createDownloadFile(data, 'sample_product_csv.csv');
        },
        error => {
          console.log(error);
        });
    }
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    this.chosenFile = this.fileToUpload.name;
    this.complete = false;
    this.isSave = false;
  }

  reportUploadResultComplete(data) {
    if (data.success.length !== 0) {
      this.fileReport.success = data.success + ' ' + this.translate.instant("ABB-DASHBOARD.UPLOAD.SUCCESS");
      this.complete = true;
      this.chosenFile = `${this.translate.instant("ABB-DASHBOARD.IMPORT-CSV")} ${this.translate.instant("ABB-DASHBOARD.UPLOAD.UPLOAD-COMPLETE")}`;
      return;
    }
    this.fileReport.validate_fail = data.validate_fail;
    this.fileReport.operate_fail = data.operation_fail;
    this.complete = true;
    this.chosenFile = this.translate.instant("ABB-DASHBOARD.UPLOAD.SUCCESS");
  }

  reportUploadResultError(error) {
    if (error.error.validate_fail || error.error.operation_fail) {
      this.fileReport.validate_fail = error.error.validate_fail;
      this.fileReport.operate_fail = error.error.operation_fail;
    } else {
      this.fileReport.validate_fail = error.error;
    }
  }

  uploadFileToDatabase() {
    if (this.fileToUpload) {
      this.loading = true;
      const document = new FormData();
      document.append('file', this.fileToUpload);
      const get_format = this.fileToUpload.name.split(".");
      const file_format = get_format.slice(-1).pop();
      this.fileReport = {
        success: '',
        duplicate: '',
        operate_fail: '',
        validate_fail: ''
      };
      if (file_format === 'csv') {
        this.apiService.uploadCSVABB(document).subscribe(
          data => {
            this.loading = false;
            this.reportUploadResultComplete(data);
            this.loadData();
          },
          error => {
            this.loading = false;
            this.reportUploadResultError(error);
            this.isSave = true;
          });
      }
      this.fileToUpload = null;
    } else {
      this.isSave = true;
      this.chosenFile = this.translate.instant("ABB-DASHBOARD.NO-FILE-CHOSEN");
    }
  }

  submit() {
    if (this.complete) {
      this.modal.close();
      return;
    }
    this.uploadFileToDatabase();
    return;
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-list/product-list.component.ts